import { render, staticRenderFns } from "./createStudent.vue?vue&type=template&id=0afa0855&"
import script from "./createStudent.vue?vue&type=script&lang=js&"
export * from "./createStudent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports